<script setup lang="ts">
import type { ActivationUser } from '../../../modules/users/models/user.model'

import LineDivider from '@/shared/components/divider/LineDivider.vue'
import TextField from '@/shared/components/text/TextField.vue'

interface Props {
  user: ActivationUser
}

defineProps<Props>()
</script>

<template>
  <div class="flex flex-col gap-2 mt-2">
    <template
      v-if="user.initialFirstName || user.initialLastName || user.initialEmail || user.initialPhone"
    >
      <LineDivider :title="'Registration Information'" />
      <div class="flex gap-4">
        <TextField
          :label="$t('glossary.initialFirstName')"
          :value="user.initialFirstName"
          class="basis-1/2"
        />
        <TextField
          :label="$t('glossary.initialLastName')"
          :value="user.initialLastName"
          class="basis-1/2"
        />
      </div>
      <div class="flex gap-4">
        <TextField
          :label="$t('glossary.initialEmail')"
          :value="user.initialEmail"
          class="basis-1/2"
        />
        <TextField
          :label="$t('glossary.initialPhone')"
          :value="user.initialPhone"
          class="basis-1/2"
        />
      </div>
    </template>
    <template v-if="user.identityProvider || user.identityProviderEmail">
      <LineDivider :title="'Identity information'" />
      <div class="flex gap-4">
        <TextField
          :label="$t('glossary.identityProvider')"
          :value="user.identityProvider"
          class="basis-1/2"
        />
        <TextField
          :label="$t('glossary.identityProviderEmail')"
          :value="user.identityProviderEmail"
          class="basis-1/2"
        />
      </div>
    </template>
  </div>
</template>
